module.exports = __webpack_public_path__ + "static/img/blekey3.2db99ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/blekey/key2/blekey3.jpg
// module id = S4dI
// module chunks = 0